import type { IOption, IPractitioner } from '@frontend/components/interfaces';
import { getDisplayName } from '@common/utils/getDisplayName';
import { hasValidAgbCode } from '@common/utils/hasValidAgbCode';
import { fetchJson } from '@frontend/store/fetch';

export async function loadSupervisorOptions(
    organizationId: string,
    searchText?: string,
    excludePractitionerId?: string
) {
    let supervisors: IOption<string>[] = [];

    if (organizationId) {
        const result = await fetchJson<{ items: IPractitioner[] }>('/api/practitioners/list', 'POST', {
            filters: {
                excludeId: excludePractitionerId,
                hasActiveEmployment: true,
                organizationId: organizationId,
                searchText: searchText,
            },
            sortBy: 'name',
            whereNotNull: 'identifierDeclaration',
        });

        supervisors = result.json!.items.filter(hasValidAgbCode).map((practitioner) => {
            return {
                label: `${getDisplayName(practitioner)} - ${practitioner.identifierDeclaration}`,
                value: practitioner.id,
            };
        });
    }

    return supervisors;
}
